import Form from "react-bootstrap/Form";

const buildParagraphQuestion = (question) => {
  return (
    <Form.Control
      name={question.Name}
      as="textarea"
      minLength={question.MinLength}
      maxLength={question.MaxLength}
      rows={3}
      required={question.IsMandatory}
    ></Form.Control>
  );
};

export default buildParagraphQuestion;
